var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (
    (_vm.$session.type === 'account' ||
    _vm.$session.permissions.is('SHOW_ALL_MENUS', 'SHOP_REASSIGN')) && _vm.show
  )?_c('el-button',{staticClass:"batch-operate-btn",attrs:{"type":"text","data-matomo":_vm.$store.state.matomo[22].id},on:{"click":function($event){return _vm.autoRenew(false)}}},[_vm._v(" "+_vm._s(_vm.$t("vdcontainer.disable_automatic_renewal"))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }